<template>
	<div class="routedetails" :class="{ 'routedetails--active': visible }">
		<div class="routedetails__image">
			<img v-if="route.thumb" :src="route.thumb" :alt="route.name" />
		</div>
		<div class="routedetails__description">
			<a class="routedetails__close" @click="$emit('close')" title="Lukk"></a>
			<h2 @click="gotoRoute">{{ route.name }}</h2>
			<a class="routedetails__show" @click="gotoRoute" :href="route.url" style="text-decoration:none;color:#54565A;" >Les mer &raquo;</a>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			config: Object,
			route: { type: Object, default: () => ({}) },
			visible: { type: Boolean, default: false }
		},
		emits: ['close'],
		components: {

		},
		methods: {
			gotoRoute() {
				if (!this.route.url) {
					return;
				}
				location.href = this.route.url;
			}
		}
	}
</script>

<style>

</style>